export default __webpack_public_path__ + "static/media/962.ecba4b13.jpg";